import React from "react";
import { useSelector } from "react-redux";
import { selectAllProducts } from "../redux/slices/productsSlice";
import { selectAllProductSettings } from "../redux/slices/productSettingsSlice";
import {
    selectAllRegistration,
    selectRegistrationTotals,
    updateRegistrationTotals,
} from "../redux/slices/registrationSlice";
import { selectAllCategories } from "../redux/slices/categoriesSlice";
import { selectAllFormSettings } from "../redux/slices/formSettingsSlice";

import UpdateRegistrationTotal from "./UpdateRegistrationTotal";

const ConnectedUpdateRegistrationTotal = () => {
    const registration = useSelector(selectAllRegistration);

    const products = useSelector(selectAllProducts);

    // one time we saw the taxRate data stored as an empty string (should not have been possible)
    // so now we will force that value to be a number.
    const productSettings = useSelector(selectAllProductSettings);
    const taxRate = Number(productSettings?.taxRate) || 0;


    const {
        registrations,
        giftAssist,
        promoDiscounts: { transaction = {}, participants = [] },
        storeCart = [{}],
    } = registration;

    const {
        giftAssistAmount = 0.0,
        giftsSubtotalAmount = 0.0,
        prePromoRegistrantTotal = 0.0,
        prePromoTransTotal = 0.0,
        registrantSubtotal = 0.0,
        optionalDonationAmount = 0.0,
        shippingMethodAmount = 0.0,
        storeTaxAmount = 0.0,
        storeSubtotalAmount = 0.0,
        total = 0.0,
    } = useSelector(selectRegistrationTotals);

    const categories = useSelector(selectAllCategories);

    const formSettings = useSelector(selectAllFormSettings);
    const { feeCoverage, feeCoverageFlat, feeCoveragePercentage } =
        formSettings;

    const settings = {
        registrations,
        categories,
        optionalDonation: optionalDonationAmount,
        applyFeeCoverage: giftAssist,
        feeCoverage,
        feeCoverageFlat,
        feeCoveragePercentage,
        discounts: { transaction, participants },
        storeCart,
        products,
        taxRate,
    };

    const updateRegistrationTotalProps = {
        ...settings,
        // Redux totals
        giftAssistAmount,
        giftsSubtotalAmount,
        prePromoRegistrantTotal,
        prePromoTransTotal,
        registrantSubtotal,
        shippingMethodAmount,
        storeTaxAmount,
        storeSubtotalAmount,
        total,
        updateRegistrationTotals,
    };

    return <UpdateRegistrationTotal {...updateRegistrationTotalProps} />;
};

export default ConnectedUpdateRegistrationTotal;
